/* ============
 * Dutch Language File
 * ============
 *
 * An example language file.
 */

import * as general from './general.json';
import * as auth from './auth.json';
import * as invoice from './invoice.json';
import * as customer from './customer.json';
import * as product from './product.json';

export default {
    general,
    auth,
    invoice,
    customer,
    product,
};



// WEBPACK FOOTER //
// ./src/locale/nl/index.js